<template>
  <div v-can:[createPermission]>
    <v-btn color="accent" to="/projects/create">
      <v-icon>mdi-plus</v-icon> إضافة مشروع
    </v-btn>
  </div>
</template>

<script>
import { WRITE_PROJECTS_PERMISSION } from "@/core/statics/Permissions";

export default {
  data() {
    return {
      createPermission: WRITE_PROJECTS_PERMISSION,
    };
  },
};
</script>
